/* eslint-disable import/prefer-default-export */
import ApiService from '@/services/ApiService';

class CalendarService {
  static async getEventsCalendar() {
    const composedURL = `/api3/schedule/events/rigthbar`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getEventsTypes() {
    const composedURL = `/api3/schedule/event_type/?v=1`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getClosures(eventTypeId) {
    const composedURL = `/api3/schedule/closures/?event_type_id=${eventTypeId}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getAgent(ids) {
    const composedURL = `/api3/users/${ids}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getAgents(q) {
    const composedURL = `/api3/agent?q=${q}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getProperties(q) {
    const composedURL = `/api3/property?q=${q}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getProperty(id) {
    const composedURL = `/api3/property?id=${id}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getEvents(q) {
    const composedURL = `/api3/schedule/event/?users=${JSON.stringify(q)}&?v=1`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getEvent(q) {
    const composedURL = `/api3/schedule/event/${q}/`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getEventWithClosures(q) {
    const composedURL = `/api3/schedule/events/${q}/`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async createEvent(data) {
    const composedURL = `/api3/schedule/event/create`;
    const response = await ApiService.post(composedURL, data);
    return response;
  }

  static async deleteEvent(id) {
    const composedURL = `/api3/schedule/event/${id}/delete`;
    const response = await ApiService.delete(composedURL);
    return response;
  }

  static async eventDone(data) {
    const composedURL = `/api3/schedule/event/${data.id}/done`;
    const response = await ApiService.post(composedURL, data.body);
    return response;
  }

  static async eventDoneWithClosure(data) {
    const composedURL = `/api3/schedule/events/${data.id}/finish/`;
    const response = await ApiService.post(composedURL, data.body);
    return response;
  }

  static async editEvent(data) {
    const composedURL = `/api3/schedule/event/${data.id}/edit`;
    const response = await ApiService.put(composedURL, data.body);
    return response;
  }

  static async excludeDates(data) {
    const composedURL = `/api3/schedule/event/${data.id}/exclude_dates`;
    const response = await ApiService.post(composedURL, data.body);
    return response;
  }

  static async editOneInstance(data) {
    const composedURL = `/api3/schedule/event/${data.id}/edit_one_instance`;
    const response = await ApiService.put(composedURL, data.body);
    return response;
  }

  static async doneOneInstance(data) {
    const composedURL = `/api3/schedule/event/${data.id}/done_one_instance`;
    const response = await ApiService.post(composedURL, data.body);
    return response;
  }

  static async confirmVisit(data) {
    const composedURL = `/api3/schedule/event/confirm`;
    const response = await ApiService.put(composedURL, data);
    return response;
  }

  static async getPlainTextFromDynamicTags(data) {
    const composedURL = `/api3/schedule/events/${data.eventId}/replace_dynamic_tags/`;
    const response = await ApiService.post(composedURL, {
      message: data.message,
    });
    return response;
  }

  /**
   * Timeline events for a CRM contact. Returns `{ events, total }`.
   *
   * @param {Object} params
   * @param {number} params.contactId - CRM contact id.
   * @param {string} params.dateFrom - ISO start date (inclusive).
   * @param {string} params.dateTo - ISO end date (inclusive).
   * @param {number} [params.limit=10] - Page size.
   * @param {number} [params.offset=0] - Pagination offset.
   * @returns {Promise<{ events: Array, total: number }>}
   */
  static async getContactEvents({
    contactId,
    dateFrom,
    dateTo,
    limit = 10,
    offset = 0,
  } = {}) {
    const composedURL = `/api3/schedule/event/?contact=${contactId}&date_from=${encodeURIComponent(
      dateFrom
    )}&date_to=${encodeURIComponent(dateTo)}&limit=${limit}&offset=${offset}`;
    const response = await ApiService.get(composedURL);
    return response;
  }
}

export default CalendarService;
